function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var TeaserTemplate = require('./teaser.template');
var Summary = require('../summary');
var _require = require('../summary'),
  DREAMSCAPE_PLACEHOLDER = _require.DREAMSCAPE_PLACEHOLDER;
var _require2 = require('./summary-cache'),
  listingTeaserDataAttrs = _require2.listingTeaserDataAttrs,
  listingTeaserSelector = _require2.listingTeaserSelector;
var Teaser = /*#__PURE__*/function () {
  function Teaser(app, mod) {
    var summary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var container = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    _classCallCheck(this, Teaser);
    this.app = app;
    this.mod = mod;
    this.summary = summary;
    this.container = container;
  }
  return _createClass(Teaser, [{
    key: "render",
    value: function render() {
      var _this$summary$returnS, _this$summary, _this$summary$returnP, _this$summary2, _ref, _ref2, _this$summary$show_bu;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!this.container || !(this.summary instanceof Summary)) {
        return;
      }
      var display = this.summary.returnMediaDisplay();
      var image = this.summary.hasLoadedImage() ? this.summary.returnImage() : this.summary.returnPlaceholderImage();
      var mediaClass = this.returnMediaClass(image, display);
      var mediaBackground = this.returnMediaBackground(image, display);
      var showLoading = !!display.loading;
      var seller = ((_this$summary$returnS = (_this$summary = this.summary).returnSeller) === null || _this$summary$returnS === void 0 ? void 0 : _this$summary$returnS.call(_this$summary)) || this.summary.seller || '';
      var identicon = this.app.keychain.returnIdenticon(seller);
      var shortSeller = !seller || seller.length <= 18 ? seller || 'anon' : "".concat(seller.slice(0, 8), "\u2026").concat(seller.slice(-6));
      var price = Teaser.formatListingPrice(((_this$summary$returnP = (_this$summary2 = this.summary).returnPrice) === null || _this$summary$returnP === void 0 ? void 0 : _this$summary$returnP.call(_this$summary2)) || '');
      var templateData = {
        title: this.summary.returnTitle() || 'Untitled Item',
        price: price,
        seller: shortSeller,
        identicon: identicon,
        show_buy_now: (_ref = (_ref2 = (_this$summary$show_bu = this.summary.show_buy_now) !== null && _this$summary$show_bu !== void 0 ? _this$summary$show_bu : this.summary.can_buy) !== null && _ref2 !== void 0 ? _ref2 : this.summary.badge) !== null && _ref !== void 0 ? _ref : false
      };
      this.app.browser.addElementToSelector(TeaserTemplate(templateData, listingTeaserDataAttrs(this.summary), mediaClass, mediaBackground, showLoading), this.container);
      if (!display.loading) {
        Teaser.applyMediaDisplay(this.app, this.summary, display);
      }
      this.attachEvents();
      this.beginMediaEnrichment();
    }
  }, {
    key: "beginMediaEnrichment",
    value: function beginMediaEnrichment() {
      var _this = this;
      if (!this.summary.isImageLoading() || this.summary._media_enriched) {
        return;
      }
      Teaser.setMediaLoading(this.app, this.summary, true);
      this.summary.enrichMedia(function () {
        Teaser.updateMedia(_this.app, _this.summary);
      });
    }
  }, {
    key: "returnMediaClass",
    value: function returnMediaClass() {
      var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (display.backgroundImage || display.innerHtml) {
        return display.backgroundImage ? 'has-image' : 'has-media-content';
      }
      if (!image) {
        return 'placeholder';
      }
      return 'has-image';
    }
  }, {
    key: "returnMediaBackground",
    value: function returnMediaBackground() {
      var _this$summary$returnP2, _this$summary3;
      var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fallback = ((_this$summary$returnP2 = (_this$summary3 = this.summary).returnPlaceholderImage) === null || _this$summary$returnP2 === void 0 ? void 0 : _this$summary$returnP2.call(_this$summary3)) || DREAMSCAPE_PLACEHOLDER;
      var raw = display.backgroundImage || image || fallback;
      if (!this.app.browser.isSafeMediaUrl(raw)) {
        return "url(\"".concat(fallback, "\") center / cover no-repeat");
      }
      return "url(\"".concat(String(raw).replace(/"/g, '%22'), "\") center / cover no-repeat");
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var root = this.container ? document.querySelector(this.container) : null;
      if (!root) {
        return;
      }
      var selector = listingTeaserSelector(this.summary);
      if (!selector) {
        return;
      }
      var cards = root.querySelectorAll(selector);
      var teaserCard = cards[cards.length - 1];
      if (!teaserCard) {
        return;
      }
      var open = function open(e) {
        var _this2$mod$main, _this2$mod$main2, _detail$open;
        e.preventDefault();
        var detail = ((_this2$mod$main = _this2.mod.main) === null || _this2$mod$main === void 0 ? void 0 : _this2$mod$main.listing_detail) || ((_this2$mod$main2 = _this2.mod.main) === null || _this2$mod$main2 === void 0 ? void 0 : _this2$mod$main2.product_overlay);
        detail === null || detail === void 0 || (_detail$open = detail.open) === null || _detail$open === void 0 || _detail$open.call(detail, _this2.summary);
      };
      teaserCard.onclick = open;
      teaserCard.onkeydown = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          open(e);
        }
      };
    }
  }], [{
    key: "formatListingPrice",
    value: function formatListingPrice(value) {
      var raw = String(value !== null && value !== void 0 ? value : '').trim();
      if (!raw) {
        return '';
      }
      var numeric = raw.replace(/SAITO/gi, '').replace(/,/g, '').trim();
      if (!numeric || !Number.isFinite(Number(numeric))) {
        return /[a-zA-Z]/.test(raw) ? raw : "".concat(raw, " SAITO");
      }
      return "".concat(Number(numeric).toLocaleString('en-US', {
        maximumFractionDigits: 8
      }), " SAITO");
    }

    /** All mounted teaser instances for this listing (browse + storefront, etc.). */
  }, {
    key: "returnTeaserCards",
    value: function returnTeaserCards(summary) {
      var selector = listingTeaserSelector(summary);
      if (!selector || typeof document === 'undefined') {
        return [];
      }
      return Array.from(document.querySelectorAll(selector));
    }
  }, {
    key: "setMediaLoading",
    value: function setMediaLoading(app, summary) {
      var loading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _iterator = _createForOfIteratorHelper(Teaser.returnTeaserCards(summary)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var card = _step.value;
          var media = card.querySelector('.media');
          if (media) {
            media.classList.toggle('loading', loading);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "updateMedia",
    value: function updateMedia(app, summary) {
      if (!(summary instanceof Summary) || !summary.nft_id) {
        return;
      }
      Teaser.applyMediaDisplay(app, summary, summary.returnMediaDisplay());
      Teaser.applyInfoDisplay(summary);
    }
  }, {
    key: "applyInfoDisplay",
    value: function applyInfoDisplay(summary) {
      var _summary$hydrateFromL, _summary$returnSeller, _summary$returnPrice;
      if (!(summary instanceof Summary)) {
        return;
      }
      var cards = Teaser.returnTeaserCards(summary);
      if (!cards.length) {
        return;
      }
      (_summary$hydrateFromL = summary.hydrateFromListingTransaction) === null || _summary$hydrateFromL === void 0 || _summary$hydrateFromL.call(summary);
      var title = summary.returnTitle() || 'Untitled Item';
      var seller = ((_summary$returnSeller = summary.returnSeller) === null || _summary$returnSeller === void 0 ? void 0 : _summary$returnSeller.call(summary)) || summary.seller || '';
      var shortSeller = !seller || seller.length <= 18 ? seller || 'anon' : "".concat(seller.slice(0, 8), "\u2026").concat(seller.slice(-6));
      var price = Teaser.formatListingPrice(((_summary$returnPrice = summary.returnPrice) === null || _summary$returnPrice === void 0 ? void 0 : _summary$returnPrice.call(summary)) || '');
      var _iterator2 = _createForOfIteratorHelper(cards),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var card = _step2.value;
          var titleEl = card.querySelector('.title');
          if (titleEl) {
            titleEl.textContent = title;
          }
          var sellerEl = card.querySelector('.info .seller');
          if (shortSeller) {
            if (!sellerEl) {
              var _card$querySelector;
              sellerEl = document.createElement('p');
              sellerEl.className = 'seller';
              (_card$querySelector = card.querySelector('.info')) === null || _card$querySelector === void 0 || _card$querySelector.appendChild(sellerEl);
            }
            sellerEl.textContent = shortSeller;
          }
          var media = card.querySelector('.media');
          var priceEl = card.querySelector('.price');
          if (price) {
            if (!priceEl) {
              priceEl = document.createElement('div');
              priceEl.className = 'price';
              media === null || media === void 0 || media.appendChild(priceEl);
            }
            priceEl.textContent = price;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "applyMediaToElement",
    value: function applyMediaToElement(app, media) {
      var _app$browser, _app$browser$isSafeMe;
      var display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DREAMSCAPE_PLACEHOLDER;
      if (!media) {
        return;
      }
      media.classList.toggle('loading', !!display.loading);
      if (display.loading) {
        return;
      }
      media.classList.remove('placeholder', 'has-image', 'loading', 'has-media-content');
      var content = media.querySelector('.media-content');
      if (display.innerHtml) {
        if (!content) {
          content = document.createElement('div');
          content.className = 'media-content';
          media.insertBefore(content, media.firstChild);
        }
        content.innerHTML = display.innerHtml;
      } else if (content) {
        content.remove();
      }
      var bg = display.backgroundImage;
      if (bg && app !== null && app !== void 0 && (_app$browser = app.browser) !== null && _app$browser !== void 0 && (_app$browser$isSafeMe = _app$browser.isSafeMediaUrl) !== null && _app$browser$isSafeMe !== void 0 && _app$browser$isSafeMe.call(_app$browser, bg)) {
        media.classList.add('has-image');
        media.style.background = "url(\"".concat(String(bg).replace(/"/g, '%22'), "\") center / cover no-repeat");
        return;
      }
      if (!display.innerHtml) {
        media.classList.add('placeholder');
        media.style.background = "url(".concat(placeholder, ") center / cover no-repeat");
      } else {
        media.style.background = '';
      }
    }
  }, {
    key: "applyMediaDisplay",
    value: function applyMediaDisplay(app, summary) {
      var display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var placeholder = typeof (summary === null || summary === void 0 ? void 0 : summary.returnPlaceholderImage) === 'function' ? summary.returnPlaceholderImage() : DREAMSCAPE_PLACEHOLDER;
      var _iterator3 = _createForOfIteratorHelper(Teaser.returnTeaserCards(summary)),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var card = _step3.value;
          Teaser.applyMediaToElement(app, card.querySelector('.media'), display, placeholder);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);
}();
module.exports = Teaser;